export default "__VITE_ASSET__8616aafa__"